// src/pages/administrativo/EmpresaCad.js
import React, { useState, useEffect } from 'react';

import Input from '../../components/input/Input.js';
import { useEmpresa } from '../../contexts/administrativo/EmpresaContext.js'; 
import EmpresaSearch from './EmpresaSearch';
import Select from '../../components/input/Select.js';
import { Empresa } from '../../models/geral/Empresa.ts';
import { useMessage } from '../../contexts/geral/MessageContext.js';
import { useYesNo } from '../../contexts/geral/YesNoContext.js';

import ModalContainer from '../../components/modalForm/ModalContainer';
import ModalHeader from '../../components/modalForm/ModalHeader';
import ModalBody from '../../components/modalForm/ModalBody';
import ModalFooter from '../../components/modalForm/ModalFooter';
import ModalActions, { ModalActionButton } from '../../components/modalForm/ModalActions';

const EmpresaCad = ({ show, onHide }) => {
    const { empresas, addEmpresa, updateEmpresa, deleteEmpresa } = useEmpresa();
    const [empresa, setEmpresa] = useState( new Empresa());
    const [showSearchModal, setShowSearchModal] = useState(false);
    const {showMessage} = useMessage();
    const { showYesNo } = useYesNo();
    const [novoReg, setNovoReg] = useState(false);

    useEffect(() => {
        setEmpresa(new Empresa());
    }, []);

    const handleNovo = () => {
        setEmpresa(new Empresa());
        setNovoReg(true);
    };

    const handleEditar = (id) => {
        if (id === 0) {
            showMessage("Selecione uma empresa para editar!");            
            return;
        }
        setNovoReg(false);
    };

    const handleDelete = async () => {
        if (!empresa?.id) {
            showMessage("Selecione uma empresa para excluir!");            
        } else {
            const resposta = await showYesNo("Deseja excluir a empresa selecionada?");
            if (resposta) {
                await deleteEmpresa(empresa.id);
                handleNovo();
            }
        }
    };

    const handleSave = async () => {
        try {
            if (!empresa.nome) {
                showMessage("Nome da empresa não preenchido!");                
                return;
            }

            if (!empresa.id) {
                await addEmpresa(empresa);
            } else {
                await updateEmpresa(empresa);
            }
            handleNovo();
        } catch (error) {
            console.error("Erro ao gravar dados: ", error);
        }
    };

    const handleExit = () => {
        const empresaSelecionada = empresas.find(e => e.id.toString() === empresa?.id?.toString());

        if (empresaSelecionada) {
            setEmpresa(empresaSelecionada);
            handleEditar(empresa?.id);
        } else {
            setEmpresa(new Empresa());
        }
    };

    const handleSelectEmpresa = (empresaSel) => {
        setEmpresa(empresaSel);
        setShowSearchModal(false);
        if (empresaSel) {
            handleEditar(empresaSel.id);
        } else {
            setEmpresa(new Empresa());
        }
    };

    const CRTEnum = {
        SimplesNacional: 1,
        SimplesExcessoReceita: 2,
        RegimeNormal: 3,
        MEI: 4
    };

    const CRTOptions = [
        { value: "", label: 'Selecione...' },
        { value: CRTEnum.SimplesNacional, label: 'Simples Nacional' },
        { value: CRTEnum.SimplesExcessoReceita, label: 'Simples - Excesso de Receita' },
        { value: CRTEnum.RegimeNormal, label: 'Regime Normal' },
        { value: CRTEnum.MEI, label: 'MEI' },
    ];

    if (!show) return null;

    return (
        <ModalContainer show={show} largura="600px" variant="cadastro" onHide={onHide}>

            <ModalHeader title={novoReg ? 'Nova Empresa' : 'Alterar Empresa'} onHide={onHide} />
            <ModalBody className="modal-body">
                <form>
                    <div className="input-group mb-3">
                        <Input
                            label="Código"
                            value={empresa.id || ''}
                            onChange={(e) => setEmpresa({ ...empresa, id: e.target.value })}
                            onBlur={handleExit}
                            disabled={!novoReg}
                            btnBuscar={() => setShowSearchModal(true)}
                        />
                        <Input
                            label="Nome"
                            value={empresa.nome || ''}
                            onChange={(e) => setEmpresa({ ...empresa, nome: e.target.value })}
                            size={300}
                            autoFocus={true}
                        />
                    </div>
                    <div className="input-group">
                        <Select
                            label="CRT"
                            value={empresa.crt || ""}
                            onChange={(e) => setEmpresa({ ...empresa, crt: parseInt(e.target.value) })}
                            options={CRTOptions}
                            size={300}
                        />
                    </div>
                </form>
            </ModalBody>
            <ModalFooter className="modal-footer justify-content-end">
                <ModalActions >
                    <ModalActionButton className="btn btn-primary" onClick={handleSave} action="save">
                        Salvar
                    </ModalActionButton>
                    <ModalActionButton className="btn btn-danger" onClick={handleDelete} disabled={novoReg} action="delete">
                        Excluir
                    </ModalActionButton>
                    <ModalActionButton className="btn btn-secondary" onClick={handleNovo} disabled={novoReg} action="new">
                        Novo
                    </ModalActionButton>
                </ModalActions>
            </ModalFooter>

            <EmpresaSearch
                show={showSearchModal}
                onHide={() => setShowSearchModal(false)}
                onSelectEmpresa={handleSelectEmpresa}
            />

        </ModalContainer>
    );
};

export default EmpresaCad;
